import { render, staticRenderFns } from "./ProductUpdate.vue?vue&type=template&id=f50ff8e2"
import script from "./ProductUpdate.vue?vue&type=script&lang=js"
export * from "./ProductUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProductUpdate.vue?vue&type=style&index=0&id=f50ff8e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports